import Model from "./Model";

export const defaultMeasureAuditCompany: IMeasureAuditCompany = {
  measure: "",
  month: 0,
  year: 0,
  timestamp: 0,
  id: "",
  uid: "",
  userName: "",
  objective: "",
  department: "",
  perspective: "",
  description: "",
  comments: "",
  sourceOfEvidence: "",
  statusUpdate: "",
  activities: "",
  quarter1Target: null,
  quarter2Target: null,
  quarter3Target: null,
  quarter4Target: null,
  quarter1Actual: null,
  quarter2Actual: null,
  quarter3Actual: null,
  quarter4Actual: null,
  baseline: null,
  rating1: null,
  rating2: null,
  rating3: null,
  rating4: null,
  rating5: null,
  annualTarget: null,
  annualActual: null,
  targetDate: "",
  q1AutoRating: 0,
  q1Rating: null,
  q2AutoRating: 0,
  q2Rating: null,
  q3AutoRating: 0,
  q3Rating: null,
  q4AutoRating: 0,
  q4Rating: null,
  weight: 0,
  dataType: "",
  dataSymbol: "",
  symbolPos: "prefix",
  q2supervisorRating: null,
  q2FinalRating: null,
  q4rating: null,
  q4supervisorRating: null,
  q4FinalRating: null,
  rating: null
};

export interface IMeasureAuditCompany {
  id: string;
  uid: string;
  userName: string;
  objective: string;
  department: string;
  perspective: string; // Financial, Customer, Operational, Learning & Growth
  measure: string;
  description: string;
  comments: string;
  sourceOfEvidence: string;
  statusUpdate: string;
  activities: string;

  quarter1Target: number | null;
  quarter2Target: number | null;
  quarter3Target: number | null;
  quarter4Target: number | null;

  quarter1Actual: number | null;
  quarter2Actual: number | null;
  quarter3Actual: number | null;
  quarter4Actual: number | null;

  baseline: number | null;

  rating1: number | null;
  rating2: number | null;
  rating3: number | null;
  rating4: number | null;
  rating5: number | null;

  annualTarget: number | null;
  annualActual: number | null;
  midtermActual?: number | null;

  targetDate: number | string;

  q1AutoRating: number;
  q1Rating: number | null;

  q2AutoRating: number;
  q2Rating: number | null;
  q2supervisorRating: number | null;
  q2FinalRating: number | null;

  q3AutoRating: number;
  q3Rating: number | null;

  q4AutoRating: number;
  q4Rating: number | null;
  q4rating: number | null;
  q4supervisorRating: number | null;
  q4FinalRating: number | null;

  rating: number | null;

  weight: number;

  dataType: string;
  dataSymbol: string;
  symbolPos: "prefix" | "suffix";

  month: number;
  year: number;
  timestamp: number;
}


export default class MeasureAuditCompany extends Model<IMeasureAuditCompany> {
  update(): void { }

  edit(): void { }

  async remove() {
    if (!window.confirm("Continue to delete?")) return;
  }
}
